import { render, staticRenderFns } from "./Beneficios_aliados.vue?vue&type=template&id=4ceffcee&scoped=true&"
import script from "./Beneficios_aliados.vue?vue&type=script&lang=js&"
export * from "./Beneficios_aliados.vue?vue&type=script&lang=js&"
import style0 from "./Beneficios_aliados.vue?vue&type=style&index=0&id=4ceffcee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceffcee",
  null
  
)

export default component.exports